import { createAction, props } from '@ngrx/store';
import { PayComponent } from '../models/payroll.model';

// Load Paystub Components
export const loadPayComponents = createAction('[Payment->PayComponents] Load Pay Components', props<{ organizationId: string, clientId: string }>());
export const loadPayComponentsSuccess = createAction('[Payment->PayComponents] Load Pay Components Success', props<{ paystubComponents: PayComponent[] }>());
